import { asyncAction } from "../common"
import { limsRequest } from "./limsRequest"

// Append-only LIMS audit trail (GMP: who / what / when / why). Entries are NEVER edited
// or deleted — there is no update/delete path here or in the UI.
//
// SPEC-021 (B4): the audit trail is SERVER-DERIVED. Every LIMS mutation endpoint writes its
// own immutable, server-stamped entry (actor / initials / timestamp from the authenticated
// member — never the client); there is NO POST /lims/audit and no client writeAudit any more.
// This slice only READS the trail (GET /lims/audit, newest first — the server's ordering and
// timestamps are authoritative, so no client-side sorting either).
//
// SPEC-016 (calculation engine): a calculated result value carries its raw inputs + formula +
// computed value INSIDE the result record, so they ride along with the server's
// `limsAuditResultSaved` snapshot (objectType "result") — the computed value is reproducible
// from the audited record.

// Canonical set of object types the LIMS module audits — kept complete here so the audit
// viewer's Type filter lists every category, not only those that already appear in the log.
// Mirrors the objectType values the BACKEND writes across the /lims routes. "consumable" is
// the generalised reagent register (PRD-003 Area 3); "reagent" is RETAINED so historical
// reagent-era audit entries written before the rename stay filterable. "review" is the
// review-action audit (PRD-003 Area 1). "qaDecision", "batch" and "rerun" are the
// OOS -> QA -> rerun audit categories (PRD-003 Area 4 / SPEC-010). "investigation" and "capa"
// are the structured OOS-investigation + CAPA categories (PRD-005 Area 4 / SPEC-018). "sst" is
// the System Suitability Test category (PRD-005 Area 3 / SPEC-017).
export const AUDIT_OBJECT_TYPES = [
  "member", "product", "consumable", "reagent", "sample", "oos",
  "result", "review", "forskrift", "qaDecision", "batch", "rerun",
  "investigation", "capa", "sst",
]

const initialState = { entries: [], isLoading: false }

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "limsAudit/fetch/BEGIN":
      return { ...state, isLoading: true }
    case "limsAudit/fetch":
      return { entries: action.res, isLoading: false }
    case "auth/logout":
      return initialState
    default:
      return state
  }
}

export const fetch = asyncAction("limsAudit/fetch", (_dispatch) => {
  return limsRequest("GET", "/lims/audit").then((res) => res.items)
})

export const selectAuditEntries = (state) => state.limsAudit.entries
